<template>
    <div class="operateClassN">
        <div class="headerT">奖惩情况</div>
        <div style="width: 100%">
            <div class="mgt-10 leftT">
                <div class="titleBg">
                    <el-row type="flex" align="middle">
                        <div class="titleBox"></div>
                        <div class="pl-1">驾驶员累计奖惩情况</div>
                    </el-row>
                </div>
                <div class="rowCent rowjcenter mgt-10">
                    <div class="navList rowCent rowCentRl">
                        <div style="width: 50%">
                            <div
                                v-if="list.punishmentNum === 0"
                                class="col-00E0FD"
                                style="font-size: 30px"
                            >
                                0次
                            </div>
                            <div
                                v-if="list.punishmentNum !== 0"
                                class="col-00E0FD"
                                style="font-size: 30px"
                            >
                                {{
                                    list.punishmentNum
                                        ? list.punishmentNum
                                        : "--"
                                }}次
                            </div>
                            <div class="mt-1">累计处罚情况</div>
                        </div>
                        <div
                            style="
                                background-color: rgba(255, 255, 255, 0.1);
                                width: 1px;
                                height: 76px;
                            "
                        ></div>
                        <div>
                            <div class="rowCent"></div>
                            <div style="margin-top: 20px"></div>
                            <div class="rowCent">
                                <div>环比</div>
                                <div
                                    v-if="!list.punishmentNumYearRingRatio"
                                    style="padding: 0 10px"
                                >
                                    {{
                                        list.punishmentNumYearRingRatio === 0
                                            ? "0%"
                                            : "--"
                                    }}
                                </div>
                                <div
                                    v-if="list.punishmentNumYearRingRatio > 0"
                                    style="color: #15dd8f"
                                >
                                    <i
                                        class="el-icon-caret-top"
                                        style="padding: 0 5px"
                                    ></i
                                    >{{ list.punishmentNumYearRingRatio }}%
                                </div>
                                <div
                                    v-if="list.punishmentNumYearRingRatio < 0"
                                    style="color: #f7333d"
                                >
                                    <i
                                        class="el-icon-caret-bottom"
                                        style="padding: 0 5px"
                                    ></i
                                    >{{ list.punishmentNumYearRingRatio }}%
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 10%; height: 10px"></div>
                    <div class="navList rowCent rowCentRl">
                        <div style="width: 50%">
                            <div
                                v-if="list.rewardNum === 0"
                                class="col-00E0FD"
                                style="font-size: 30px"
                            >
                                0次
                            </div>
                            <div
                                v-if="list.rewardNum !== 0"
                                class="col-00E0FD"
                                style="font-size: 30px"
                            >
                                {{ list.rewardNum ? list.rewardNum : "--" }}次
                            </div>
                            <div class="mt-1">累计奖励情况</div>
                        </div>
                        <div
                            style="
                                background-color: rgba(255, 255, 255, 0.1);
                                width: 1px;
                                height: 76px;
                            "
                        ></div>
                        <div>
                            <div class="rowCent"></div>
                            <div style="margin-top: 20px"></div>
                            <div class="rowCent">
                                <div>环比</div>
                                <div
                                    v-if="!list.rewardNumYearRingRatio"
                                    style="padding: 0 10px"
                                >
                                    {{ list.mentalNum === 0 ? "0%" : "--" }}
                                </div>
                                <div
                                    v-if="list.rewardNumYearRingRatio > 0"
                                    style="color: #15dd8f"
                                >
                                    <i
                                        class="el-icon-caret-top"
                                        style="padding: 0 5px"
                                    ></i
                                    >{{ list.rewardNumYearRingRatio }}%
                                </div>
                                <div
                                    v-if="list.rewardNumYearRingRatio < 0"
                                    style="color: #f7333d"
                                >
                                    <i
                                        class="el-icon-caret-bottom"
                                        style="padding: 0 5px"
                                    ></i
                                    >{{ list.rewardNumYearRingRatio }}%
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="follow mgt-10">
                <div class="titleBg">
                    <el-row type="flex" align="middle">
                        <div class="titleBox"></div>
                        <div class="pl-1">驾驶员累计奖惩情况</div>
                    </el-row>
                </div>
                <div style="width: 1px; height: 15px"></div>
                <div class="tableClass">
                    <div class="rowCent w100Bg mgt-10">
                        <div class="w30">时间</div>
                        <div class="w30">类型</div>
                        <div class="w30">人员</div>
                        <div class="w70">事件</div>
                    </div>
                    <div class="tableOver">
                        <div
                            class="rowCent w100"
                            v-for="(item, index) in table.list"
                            :key="index"
                        >
                            <div class="w30">
                                {{ item.rewardPunishmentTime }}
                            </div>
                            <div class="w30">
                                {{ item.rewardPunishmentTypeName }}
                            </div>
                            <div class="w30">{{ item.realName }}</div>
                            <div class="w70">{{ item.event }}</div>
                        </div>
                        <div v-if="table.list.length < 1" class="noData"></div>
                    </div>
                    <el-pagination
                        :current-page="table.currentPage"
                        :page-sizes="[5, 10, 15, 20, 50, 100]"
                        :page-size="table.pageSize"
                        layout="total, ->, prev, pager, next"
                        :total="table.total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Operate",
    props: {
        row: {
            type: Object,
            default: () => {},
        },
        info: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            dateTime: "",
            table: {
                list: [],
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },
            list: {},
        };
    },
    created() {},
    mounted() {},
    methods: {
        handleParentClick(v) {
            this.dateTime = v;
            this.table.currentPage = 1;
            this.table.total = 0;
            this.table.list = [];
            this.getDepartYearRewardPunishmentDetails();
        },
        getDepartYearRewardPunishmentDetails() {
            let that_ = this;
            this.$axiosReq(
                "/archives/server/escort/web/rewardPunishment/getDepartYearRewardPunishmentDetails2",
                null,
                {
                    pageSize: this.table.pageSize,
                    currentPage: this.table.currentPage,
                    date: this.dateTime + "-01",
                    companyId: this.info.companyId,
                    departId: this.row.departId,
                },
                "get"
            ).then((res) => {
                // console.log(JSON.stringify(res));
                that_.list = res.data;
                if (
                    res.data.creditRewardPunishmentPageVo &&
                    res.data.creditRewardPunishmentPageVo.content.length > 0
                ) {
                    that_.table.list =
                        res.data.creditRewardPunishmentPageVo.content;
                    that_.table.total = Number(
                        res.data.creditRewardPunishmentPageVo.totalElements
                    );
                }
            });
        },
        handleSizeChange(pageSize) {
            this.table.pageSize = pageSize;
            this.table.currentPage = 1;
            this.getDepartYearRewardPunishmentDetails();
        },
        handleCurrentChange(currentPage) {
            this.table.currentPage = currentPage;
            this.getDepartYearRewardPunishmentDetails();
        },
    },
};
</script>

<style scoped>
.col-00E0FD {
    color: #00e0fd;
}

.operateClassN {
    width: 100%;
    height: 100%;
}

.headerT {
    color: #42f3f9;
    font-size: 20px;
    padding-left: 10px;
    border-left: 3px solid #42f3f9;
    margin-top: 10px;
}

.mgt-10 {
    margin-top: 10px;
}

.rowCent {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    box-sizing: border-box;
}

.rowjaround {
    justify-content: space-around;
}

.rowjcenter {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.rowCentRl {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.navList {
    width: 18%;
    height: 136px;
    background-image: url(../borderBg.png);
    background-size: 100% 100%;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
}

.navListOne {
    width: 59px;
    height: 59px;
    background-image: url(../navListOne.png);
    background-size: 100% 100%;
}

.summary {
    width: 100%;
    height: 233px;
    background-image: url(../bgAll.png);
    background-size: 100% 100%;
    padding: 10px;
    box-sizing: border-box;
}

.grade {
    width: 100%;
    height: 400px;
    background-image: url(../bgAll.png);
    background-size: 100% 100%;
    padding: 10px;
    box-sizing: border-box;
}

.follow {
    width: 100%;
    height: 600px;
    background-image: url(../bgAll.png);
    background-size: 100% 100%;
    padding: 10px;
    box-sizing: border-box;
}

.titleBg {
    min-width: 100px;
    height: 25px;
    background-color: rgba(105, 246, 175, 0.12);
    padding: 0 25px 0 15px;
    border-radius: 10px 0 20px 0;
    line-height: 25px;
    font-size: 15px;
    font-weight: 600;
    display: inline-block;
}

.titleBox {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #00ff33;
}

.textOver {
    height: 180px;
    padding-top: 10px;
    line-height: 20px;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
}

.textOver::-webkit-scrollbar {
    display: none;
}

.tableOver {
    width: 100%;
    height: 380px;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    box-sizing: border-box;
}

.tableOver::-webkit-scrollbar {
    display: none;
}

.w70 {
    width: 40%;
    height: 35px;
    line-height: 35px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.w30 {
    width: 20%;
    height: 35px;
    line-height: 35px;
}

.w100 {
    width: 100%;
    text-align: center;
    height: 35px;
}

.w100Bg {
    width: 100%;
    text-align: center;
    height: 35px;
    background-color: rgba(0, 232, 255, 0.08);
}

.leftT {
    height: 210px;
    background-image: url(../bgAll.png);
    background-size: 100% 100%;
    padding-top: 10px;
    box-sizing: border-box;
}

.noData {
    width: 200px;
    height: 130px;
    background-image: url(../noData.png);
    background-size: 100% 100%;
    margin: 0 auto;
}
</style>
